module.exports = __webpack_public_path__ + "static/media/branding-img17.a2065fe6.jpg";